// DynamicMobileSearch.tsx
"use client";

import { useData } from "data/data-provider";
import MobileSearch from "../MobileSearchForm/MobileSearch";
import MobileSearch_2 from "../MobileSearchForm/MobileSerch_2";


const DynamicMobileSearch = () => {
  const { ourCompany } = useData();

  // Show the rich (tabbed) search form when EITHER long-term OR hourly
  // rentals are enabled — both need the multi-tab picker (Hours/Dates/Weeks/
  // Months). Falls back to the simpler short-term version otherwise.
  if (ourCompany?.allow_long_term_rentals || ourCompany?.allow_hourly_rentals) {
    return <MobileSearch />;
  }
  return <MobileSearch_2 />;
};

export default DynamicMobileSearch;